"use strict";

var _taggedTemplateLiteral = require("/home/circleci/b2b-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 62px;\n  width: 62px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    border: solid 5px ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    border: solid 5px ", ";\n    border-bottom-color: ", ";\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinner = void 0;

var _stylitas = require("@creditas/stylitas");

var spinnerLoading = function spinnerLoading(_ref) {
  var complete = _ref.complete,
      theme = _ref.theme;
  return !complete && (0, _stylitas.css)(_templateObject(), _stylitas.utilities.palette.color(theme, 'neutral03'), _stylitas.utilities.palette.color(theme, 'primary03'), _stylitas.utilities.animation.spin());
};

var spinnerComplete = function spinnerComplete(_ref2) {
  var complete = _ref2.complete,
      theme = _ref2.theme;
  return complete && (0, _stylitas.css)(_templateObject2(), _stylitas.utilities.palette.color(theme, 'primary03'));
};

var spinner = function spinner(_ref3) {
  var complete = _ref3.complete,
      theme = _ref3.theme;
  return (0, _stylitas.css)(_templateObject3(), spinnerLoading({
    complete: complete,
    theme: theme
  }), spinnerComplete({
    complete: complete,
    theme: theme
  }));
};

exports.spinner = spinner;